import React, { useContext } from 'react'
import ReactDOM from 'react-dom'

import DataContext from '../../contexts/data.jsx'

import Persons from './Persons.jsx'
import PropertiesGroup from './PropertiesGroup.jsx'

const ContactsStep = ({ setData }) => {
    const data = useContext(DataContext),
    handleSetContextValue = (contextData) => {
        const newContextData = Object.assign({}, contextData)

        newContextData.contacts.name = ''

        setData(newContextData)
    }

    return <div className="happy-order__step happy-order__step_contacts">
        <div className="happy-order__step-header">
            <h2 className="happy-order__step-title">Шаг 1. Тип плательщика</h2>

            <p className="happy-order__step-notice">
                Пожалуйста, укажите свои контактные данные
            </p>
        </div>

        <Persons setData={ setData } />

        { data.data.properties.map((propertyGroup) => {
            if (propertyGroup.ID == 1 || propertyGroup.ID == 3) {
                if (propertyGroup.PERSON_TYPE_ID == data.contacts.person) {
                    return <PropertiesGroup
                        key={ `contacts-property-group-${ propertyGroup.ID }` }
                        propertyGroup={ propertyGroup }
                        setData={ setData }
                    />
                } else {
                    return null
                }
            } else {
                return null
            }
        }) }
    </div>
}

export default ContactsStep